import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';

import GiftGuide from './react/GiftGuide/GiftGuide.jsx';

export function initGiftGuide() {
  const giftGuideWrapper = document.querySelector('[data-gift-guide]');

  if (giftGuideWrapper) {
    const headerBackgroundHTHML = giftGuideWrapper.querySelector('.header-background').innerHTML;
    const productsPerPage = parseInt(
      giftGuideWrapper.dataset.perPage,
      10
    ) || 12;

    const staticContents = [...giftGuideWrapper.querySelectorAll('#filterOptions li[data-static]')]
      .map((li) => {
        const element = document.getElementById(li.getAttribute('data-tag'));
        return {
          content: element ? element.innerHTML : '',
          name: li.getAttribute('data-tag')
        };
      });

    const tags = [...giftGuideWrapper.querySelectorAll('#filterOptions li')].map((li) => ({
      image: li.querySelector('img').getAttribute('src'),
      value: li.getAttribute('data-tag'),
      title: li.innerText,
      isActive: li.classList.contains('active'),
      isStatic: li.hasAttribute('data-static'),
      isExternalLink: !!li.getAttribute('data-tag').match('(http[s]?://)|(www.)'),
      isPriceFilter: li.hasAttribute('data-price')
    }));

    const items = [...giftGuideWrapper.querySelectorAll('#products .item')].map(
      (article, position) => {
        const productPageUrl = article.getAttribute('data-product');
        let productId = productPageUrl
          ? productPageUrl.match('-([^-]*)-pdt.html')
          : null;
        productId = productId ? productId[1] : 0;
        return {
          guideTitle: article.querySelector('.pr-info')
            ? article.querySelector('.pr-info').innerText : null,
          image: article.querySelector('img')
            ? article.querySelector('img').getAttribute('src')
            : null,
          tags: article.getAttribute('data-tags')
            ? article.getAttribute('data-tags').split(',')
            : [],
          productPageUrl: productPageUrl,
          productId: productId,
          isDisplayed: true,
          originalPosition: position,
          extraClasses: article.getAttribute('class')
        };
      }
    );

    let activeTag = null;
    
    if (window.location.hash) {
      activeTag = tags.find((tag) => tag.value === window.location.hash.substr(1));
    } else {
      activeTag = tags.find((tag) => tag.isActive === true);
    }

    let activeTags = [activeTag];
    const urlQuery = queryString.parse(window.location.search);
    if (urlQuery.tags) {
      activeTags = tags.filter((tag) => urlQuery.tags.includes(tag.value));
    }

    const texts = {
      closeCategories: giftGuideWrapper.dataset.closeCategories || 'Close menu',
      openCategories: giftGuideWrapper.dataset.openCategories || 'Browse gifting categories',
      loadMore: giftGuideWrapper.dataset.loadMore || 'Load more',
      sortBy: giftGuideWrapper.dataset.sortBy || 'Sort products by:',
      customerRating: giftGuideWrapper.dataset.customerRating || 'Customer rating:',
      mainFeatures: giftGuideWrapper.dataset.mainFeatures || 'Main Features:',
      moreInfo: giftGuideWrapper.dataset.moreInfo || 'More info',
      productCode: giftGuideWrapper.dataset.productCode || 'Product code:',
      sflLabelBefore: giftGuideWrapper.dataset.sflLabelBefore || 'Select the',
      sflLabelAfter: giftGuideWrapper.dataset.sflLabelAfter || 'icon to Save for later',
      save: giftGuideWrapper.dataset.save || 'Save'
    };

    const displayedSwatchTypes = giftGuideWrapper.dataset.displayedSwatchTypes
      ? JSON.parse(giftGuideWrapper.dataset.displayedSwatchTypes)
      : { colour: 'Colour' };

    const storeApiUrl = window.App.settings.get('urls.store_api') || 'https://api.currys.co.uk/store/api/';

    const cdnUrl = window.App.settings.get('urls.cdn') || 'https://currys-ssl.cdn.infra.dixons.com/';

    ReactDOM.render(
      <GiftGuide
        activeTags={activeTags || [activeTag]}
        headerBackgroundHTHML={headerBackgroundHTHML}
        tags={tags}
        items={items}
        staticContents={staticContents}
        productsPerPage={productsPerPage}
        backupHTML={giftGuideWrapper.innerHTML}
        texts={texts}
        displayedSwatchTypes={displayedSwatchTypes}
        giftGuideID={giftGuideWrapper.getAttribute('id') || 'gift-guide'}
        storeApiUrl={storeApiUrl}
        cdnUrl={cdnUrl}
        stickyHeader={!!giftGuideWrapper.dataset.stickyHeader}
        showSorting={!!giftGuideWrapper.dataset.showSorting}
        showCustomerRating={!!giftGuideWrapper.dataset.showCustomerRating}
        showSfl={!!giftGuideWrapper.dataset.showSfl}
        showSflLabel={!!giftGuideWrapper.dataset.showSflLabel}
        showSflLogged={!!giftGuideWrapper.dataset.showSflLogged}
        hideSavePrice={!!giftGuideWrapper.dataset.hideSavePrice}
        toggleTagsOnMobile={!!giftGuideWrapper.dataset.toggleTagsOnMobile}
        linkTarget={giftGuideWrapper.dataset.linkTarget}
      />,
      giftGuideWrapper
    );
  }
}
